<div>
    <ng-container>
        <ng-container>
            <h2 class="title">Dish Details</h2>
        </ng-container>
        <ng-container #modalBodyview>
            <form novalidate #heroForm="ngForm" class="new-patient-form">
                <div class="sub-header">BASIC DETAILS</div>
                <div class="row">
                    <div class="col-md-4">
                        <label for="food_dishes_name" class="fnt-wght">Dish Name</label>
                        <input type="text" placeholder="Name" class="form-control custom-inp" name="dishName"
                            [(ngModel)]="dishName">
                    </div>
                    <div class="col-md-4">
                        <label for="food_dishes_name" class="fnt-wght">Dish Price</label>
                        <input type="number" placeholder="Dish Price" class="form-control custom-inp"
                            oninput="javascript: if(this.value < 0) this.value = 0" name="dishPrice"
                            [(ngModel)]="dishPrice">
                    </div>
                    <div class="col-md-4">
                        <label for="food_dishes_name" class="fnt-wght">Spice Rating</label>
                        <ng-select class="multi-select" [items]="spiceRating" bindLabel="spice_rating"
                            bindValue="spice_rating" [multiple]="false" groupBy="selectedAllGroup"
                            [selectableGroup]="true" placeholder="Select spice rating"
                            (change)="spiceRatingChangeHandeler($event)" name="Dietary" [(ngModel)]="spicerating">
                            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col-md-4">
                        <label for="food_dishes_name" class="fnt-wght">Calories</label>
                        <input type="number" placeholder="Calories" class="form-control custom-inp"
                            oninput="javascript: if(this.value < 0) this.value = 0" name="calories" [(ngModel)]="dishCalories">
                    </div>
                    <div class="col-md-4" *ngIf="!isDefaultMenu">
                        <label for="menu_label" class="fnt-wght">Menu Label</label>
                        <ng-select class="multi-select" [items]="allMenuLabel" bindLabel="dish_menu_name"
                            bindValue="id" [multiple]="false" groupBy="selectedAllGroup"
                            [selectableGroup]="true" placeholder="Select Menu Label" name="menu_label" [(ngModel)]="selectedMenu">
                            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="sub-header" style="margin-top: 25px;">ADVANCED DETAILS</div>
                <div class="row">

                    <div class="col-md-4">
                        <div class="col-md-12 col-sm-6" class="paddbottom3">
                            <label for="food_dishes_name" class="fnt-wght">Categories</label>
                            <ng-select class="multi-select" [items]="categories" bindLabel="dish_type_name"
                                bindValue="dish_type_id" [multiple]="false" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select categories"
                                (change)="catsChangeHandeler($event)" name="Dietary" [(ngModel)]="cats">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="col-md-12 col-sm-6" class="paddbottom3">
                            <label for="food_dishes_name" class="fnt-wght">Allergens</label>
                            <ng-select class="multi-select" [items]="allergens" bindLabel="allergens_name"
                                bindValue="allergens_id" [multiple]="true" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select allergens"
                                (change)="algnChangeHandeler($event)" name="Allergens" [(ngModel)]="algns">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="col-md-12 col-sm-6" class="paddbottom3">
                            <label for="food_dishes_name" class="fnt-wght">Unsuitable Dietary Preference</label>
                            <ng-select class="multi-select" [items]="allUsDietPref" bindLabel="diet_preference_name"
                                bindValue="diet_preference_id" [multiple]="true" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select unsuitable dietary"
                                (change)="usDietPrefChangeHandeler($event)" name="DietaryPref"
                                [(ngModel)]="SelectedUsDietPref">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>
                        </div>
                    </div>

                </div>
                <div class="row">

                    <div class="col-md-4">
                        <div class="col-md-12 col-sm-6" class="paddbottom3">
                            <label for="food_dishes_name" class="fnt-wght">Suitable Dietary Preference</label>
                            <ng-select class="multi-select" [items]="allStDietPref" bindLabel="diet_preference_name"
                                bindValue="diet_preference_id" [multiple]="true" groupBy="selectedAllGroup"
                                [selectableGroup]="true" placeholder="Select suitable dietary"
                                (change)="stDietPrefChangeHandeler($event)" name="DietarySuitable"
                                [(ngModel)]="SelectedStDietPref">
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="allergeOp" class="fnt-wght">Allergens Options</label>
                        <ng-select class="multi-select" [items]="allAllergenOp" bindLabel="allergens_name"
                            bindValue="allergens_id" [multiple]="true" groupBy="selectedAllGroup"
                            [selectableGroup]="true" placeholder="Select allergens options"
                            (change)="allergenOpChangeHandeler($event)" name="DietaryUnSuitable" [(ngModel)]="SelectedAllergenOp">
                            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col-md-4">
                        <label for="dietPrefOp" class="fnt-wght">Dietary Preference Options</label>
                        <ng-select class="multi-select" [items]="allAoDietPref" bindLabel="diet_preference_name"
                            bindValue="diet_preference_id" [multiple]="true" groupBy="selectedAllGroup"
                            [selectableGroup]="true" placeholder="Select dietary options"
                            (change)="aoDietPrefChangeHandeler($event)" name="DietaryOption" [(ngModel)]="SelectedAoDietPref">
                            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                            </ng-template>
                        </ng-select>
                    </div>
                </div>
                <div class="row">

                    <div class="col-md-4">
                        <label for="tagview" class="fnt-wght">Tags</label>
                        <ng-select class="multi-select" [items]="allTags" bindLabel="tag_name" bindValue="tag_id"
                            [multiple]="true" groupBy="selectedAllGroup" [selectableGroup]="true"
                            placeholder="Select tags" (change)="tagsChangeHandeler($event)" name="Tags"
                            [(ngModel)]="SelectedTags">
                            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">

                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col-md-4">
                        <tc-form-group class="mb-0 paddbottom3">
                            <label for="food_dishes_name" class="fnt-wght">Ingredients</label>
                            <tc-textarea type="text" [placeholder]="'Ingredients'"
                                [ngModelOptions]="{standalone: true}" name="ingredient" [(ngModel)]="ingredient">
                            </tc-textarea>
                        </tc-form-group>
                    </div>
                    <div class="col-md-4">
                        <tc-form-group class="mb-0" class="paddbottom3">
                            <label for="food_dishes_name" class="fnt-wght">Description</label>
                            <tc-textarea type="text" [placeholder]="'Description'"
                                [ngModelOptions]="{standalone: true}" name="description" [(ngModel)]="description" >
                            </tc-textarea>
                        </tc-form-group>
                    </div>
                    <div class="col-md-4">
                    </div>
                </div>
            </form>
        </ng-container>
        <ng-container>
            <div class="btn-main-div">
                <button tc-button [type]="'button'" [view]="'error'" (click)="close()">Close</button>
                <button tc-button [type]="'button'" [view]="'success'" (click)="addDishFunc()">Add Dish</button>

            </div>
        </ng-container>

    </ng-container>
</div>


<style>
    label {
        margin-top: 25px;
    }

    .custom-inp {
        border-radius: 22px;
        padding: 17px;
        background: #ebebeb;
    }

    .custom-inp:focus {
        /* background-color: white !important; */
        background: rgba(51, 108, 251, 0.01) !important;
        border-color: #336cfb !important;
        box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12) !important;
    }

    .sub-header {
        text-align: center;
        background: #ebebeb;
        padding: 5px 0;
    }

    .btn-main-div {
        display: flex;
        justify-content: center;
        gap: 40px;
        margin-top: 25px;
    }
</style>